import { useState } from "react";

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header">
      <a className="brand" href="#top" aria-label="Frontier State home">
        <span aria-hidden="true" className="brand-mark">✦</span>
        Frontier State
      </a>
      <button
        className="menu-button"
        type="button"
        aria-expanded={open}
        aria-controls="primary-nav"
        onClick={() => setOpen((value) => !value)}
      >
        <span className="sr-only">Toggle navigation</span>
        <span aria-hidden="true">{open ? "Close" : "Menu"}</span>
      </button>
      <nav id="primary-nav" className={open ? "primary-nav is-open" : "primary-nav"} aria-label="Primary navigation">
        <a href="#now" onClick={() => setOpen(false)}>Now</a>
        <a href="#models" onClick={() => setOpen(false)}>Models</a>
        <a href="#claims" onClick={() => setOpen(false)}>Claims</a>
        <a href="#changes" onClick={() => setOpen(false)}>Changes</a>
        <a href="#about" onClick={() => setOpen(false)}>About</a>
      </nav>
      <a className="api-shortcut" href="/api/context">&gt;_ API</a>
    </header>
  );
};

